/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimeCategoryDetails } from './timeCategoryDetails';


export interface TimeCategory { 
    cip?: TimeCategoryDetails;
    production?: TimeCategoryDetails;
    startup?: TimeCategoryDetails;
    slowing_down?: TimeCategoryDetails;
    standstill?: TimeCategoryDetails;
}

